import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

export default function HoursCalc() {
  const [tab, setTab] = useState('times');
  return (
    <CalcShell look="cnet" title="Hours Calculator" subtitle="Compute worked hours between two times or the total hours between two dates.">
      <div className="flex gap-2 mb-5 flex-wrap">
        {[['times','Hours Between Two Times'],['dates','Hours Between Two Dates']].map(([v,l]) => (
          <button key={v} onClick={() => setTab(v)} className={`px-4 py-2 rounded-full text-sm font-semibold ${tab === v ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700'}`} data-testid={`hours-tab-${v}`}>{l}</button>
        ))}
      </div>
      {tab === 'times' ? <Times /> : <Dates />}
    </CalcShell>
  );
}

function Times() {
  const [start, setStart] = useState('09:00');
  const [end, setEnd] = useState('17:30');
  const [breakMin, setBreakMin] = useState(30);
  const r = useMemo(() => {
    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = end.split(':').map(Number);
    let mins = (eh*60 + em) - (sh*60 + sm);
    if (mins < 0) mins += 24*60;
    mins -= breakMin;
    const H = Math.floor(mins/60); const M = mins % 60;
    return { H, M, decimal: mins/60 };
  }, [start, end, breakMin]);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <div className="field"><label>Start Time</label><input type="time" value={start} onChange={e => setStart(e.target.value)}/></div>
        <div className="field"><label>End Time</label><input type="time" value={end} onChange={e => setEnd(e.target.value)}/></div>
        <div className="field"><label>Break (minutes)</label><input type="number" value={breakMin} onChange={e => setBreakMin(+e.target.value || 0)}/></div>
      </div>
      <div>
        <div className="result-panel mb-4"><div className="result-title">Worked</div><div className="result-value">{r.H}h {r.M}m</div></div>
        <table className="data-table"><tbody><tr><td>Decimal hours</td><td className="text-right">{r.decimal.toFixed(2)}</td></tr></tbody></table>
      </div>
    </div>
  );
}

function Dates() {
  const [s, setS] = useState(() => new Date().toISOString().slice(0,16));
  const [e, setE] = useState(() => { const d = new Date(); d.setDate(d.getDate()+7); return d.toISOString().slice(0,16); });
  const r = useMemo(() => {
    const ms = new Date(e).getTime() - new Date(s).getTime();
    const totalSec = ms / 1000;
    const days = Math.floor(totalSec / 86400);
    const hours = Math.floor((totalSec % 86400) / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    return { days, hours, mins, totalHours: totalSec/3600, totalMinutes: totalSec/60, weeks: totalSec/(86400*7) };
  }, [s, e]);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <div className="field"><label>Start Date &amp; Time</label><input type="datetime-local" value={s} onChange={ev => setS(ev.target.value)} data-testid="hours-start"/></div>
        <div className="field"><label>End Date &amp; Time</label><input type="datetime-local" value={e} onChange={ev => setE(ev.target.value)} data-testid="hours-end"/></div>
      </div>
      <div>
        <div className="result-panel mb-3"><div className="result-title">Total Hours</div><div className="result-value" data-testid="hours-total">{r.totalHours.toFixed(2)}</div></div>
        <table className="data-table"><tbody>
          <tr><td>Days / Hours / Minutes</td><td className="text-right font-mono">{r.days}d {r.hours}h {r.mins}m</td></tr>
          <tr><td>Total minutes</td><td className="text-right font-mono">{r.totalMinutes.toFixed(0)}</td></tr>
          <tr><td>Total weeks</td><td className="text-right font-mono">{r.weeks.toFixed(3)}</td></tr>
        </tbody></table>
      </div>
    </div>
  );
}
